export default __webpack_public_path__ + "static/media/financial-info-1.83dd422a.png";